export const secondsToHHMMSS = (t: number | void): string => {
  if (t === undefined || Number.isNaN(t)) return "--:--";
  const isoStr = new Date(t * 1000).toISOString();
  if (t >= 3600) {
    return isoStr.substr(12, 7);
  }
  return isoStr.substr(14, 5);
};
